"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleMapsPropTypes = exports.UTMapPropTypes = void 0;

var _propTypes = require("prop-types");

var _formTypes = require("../../types/formTypes");

var coordinatePropType = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.func]);
var UTMapPropTypes = {
  onChange: _propTypes.func.isRequired,
  singleMarker: _propTypes.bool,
  startLocation: (0, _propTypes.shape)({
    position: (0, _propTypes.shape)({
      lat: coordinatePropType,
      lng: coordinatePropType
    }),
    key: _propTypes.number,
    defaultAnimation: _propTypes.number
  }),
  useGeolocation: _propTypes.bool,
  usePolygon: _propTypes.bool,
  placeholder: _propTypes.string,
  polygonPath: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    lat: _propTypes.number,
    lng: _propTypes.number
  })),
  onLocationOutOfBoundsCallback: _propTypes.func,
  errors: (0, _propTypes.shape)({
    retrievingLocation: _propTypes.string,
    retrieveLocationError: _propTypes.string
  }),
  className: _propTypes.string,
  field: (0, _propTypes.shape)(_propTypes.any),
  meta: _formTypes.metaPropTypes,
  input: _formTypes.inputPropTypes,
  disabled: _propTypes.bool
};
exports.UTMapPropTypes = UTMapPropTypes;
var GoogleMapsPropTypes = {
  onMapClick: _propTypes.func.isRequired,
  onMarkerRightClick: _propTypes.func.isRequired,
  center: (0, _propTypes.shape)({
    lat: coordinatePropType,
    lng: coordinatePropType
  }),
  markers: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    position: (0, _propTypes.shape)({
      lat: coordinatePropType,
      lng: coordinatePropType
    }).isRequired,
    key: _propTypes.number,
    defaultAnimation: _propTypes.number
  })),
  onMapMounted: _propTypes.func.isRequired,
  onSearchBoxMounted: _propTypes.func.isRequired,
  onPlacesChanged: _propTypes.func.isRequired,
  usePolygon: _propTypes.bool,
  polygonPath: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    lat: _propTypes.number,
    lng: _propTypes.number
  })),
  bounds: _propTypes.any,
  // eslint-disable-line react/forbid-prop-types
  onSearchChange: _propTypes.func,
  searchValue: _propTypes.any,
  // eslint-disable-line react/forbid-prop-types
  zoom: _propTypes.number,
  showOnlyMap: _propTypes.bool
};
exports.GoogleMapsPropTypes = GoogleMapsPropTypes;